import { cn } from '@/app/lib/utils';
import { FC } from 'react';
import { PuzzlePiece } from '@puzzlio/ui';

export const PuzzleDifficulty: FC<{
  difficulty: number;
  maxDifficulty: number;
  className?: string;
  iconClassName?: string;
}> = ({ difficulty, maxDifficulty, className, iconClassName }) => {
  return (
    <div className={cn('flex max-w-max gap-1', className)}>
      {Array.from({ length: maxDifficulty }).map((_, index) => (
        <PuzzlePiece
          key={index}
          style={index < difficulty ? 'full' : 'empty'}
          className={cn('size-[24px] md:size-[28px]', iconClassName)}
        />
      ))}
    </div>
  );
};
